import BlEmptyStateMv from './BlEmptyStateMv.vue'

BlEmptyStateMv.install = function(Vue) {
  Vue.component(BlEmptyStateMv.name, BlEmptyStateMv)
}

export default BlEmptyStateMv
